import {
  usePlaybackIsPlaying,
  usePlaybackIsSeeking,
  usePlaybackPause,
} from '@app/core/playback/hooks/usePlayback';
import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { useAddChunkFromSelection } from '../../../../fragment-editor/hooks/useAddChunkFromSelection';
import { usePlaySelection } from '../../../../hooks/playback/useStreamPlayback';
import { SelectionMenuEditorP } from './SelectionMenuEditorP';
import { SelectionMenuAction, useSelectionMenuCapture } from './useSelectionMenuCapture';

export function SelectionMenuEditor() {
  const isSeeking = usePlaybackIsSeeking();
  const isPlaying = usePlaybackIsPlaying();
  const pause = usePlaybackPause();
  const playSelection = usePlaySelection();
  const { clearSelection, selectionExists, selectionRange } = useStreamSelection();
  const capture = useSelectionMenuCapture();

  const { addChunkFromSelection, canAddChunk } = useAddChunkFromSelection();

  const durationMs = selectionExists ? selectionRange.to - selectionRange.from : undefined;

  const captureAndRun = (action: SelectionMenuAction, run: () => void) => {
    capture({ action, mode: 'editor', duration_ms: durationMs });
    run();
  };

  return (
    <SelectionMenuEditorP
      loadingAudio={isSeeking}
      play={isPlaying ? null : () => captureAndRun('play', () => playSelection())}
      pause={isPlaying ? () => captureAndRun('pause', () => pause()) : null}
      addChunk={canAddChunk ? () => captureAndRun('add_chunk', addChunkFromSelection) : null}
      clear={() => captureAndRun('clear', clearSelection)}
    />
  );
}
